import { useState, useCallback } from 'react'

export const useRequestState = () => {
  const [requesting, setRequesting] = useState(false)
  const [errorMessage, setErrorMessage] = useState('')

  const requestStarted = useCallback(() => {
    setRequesting(true)
    setErrorMessage('')
  }, [])

  const requestDone = useCallback(() => {
    setRequesting(false)
  }, [])

  const requestFailed = useCallback((message: string) => {
    setRequesting(false)
    setErrorMessage(message)
  }, [])

  const clearErrorMessage = useCallback(() => setErrorMessage(''), [])

  return {
    requesting,
    errorMessage,

    requestStarted,
    requestDone,
    requestFailed,
    clearErrorMessage,
  }
}
